export type GetImageDimensions = Awaited<ReturnType<typeof getImageDimensions>>;

export const getImageDimensions = async (
  imgUrl: string,
): Promise<{ height: number; width: number }> => {
  const img = new Image();
  img.src = imgUrl;

  return new Promise((resolve, reject) => {
    img.onload = (evt) => {
      const target = evt.target as HTMLImageElement;
      resolve({ width: target.width, height: target.height });
    };

    img.onerror = (error) => {
      reject(error);
    };
  });
};
